//@ts-check
import { QueryClient } from '@tanstack/react-query';

const STALE_TIME_MS = 30_000;

/** Shared TanStack Query client. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
